import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import ScrollTop from "../../../components/ScrollToTop";
import Loading from "../../../components/Loading";
import { useCardsPage } from "../cardsPageContext";
import PrivateClassCardsList from "./PrivateClassCardsList";

const useStyles = makeStyles(() => ({
  loading: {
    position: "static",
    backgroundColor: "unset",
    padding: "280px 0",
  },
}));

const FilterResults: FC = () => {
  const classes = useStyles();
  const { loading } = useCardsPage();

  return (
    <>
      {loading ? (
        <Loading className={classes.loading} />
      ) : (
        <PrivateClassCardsList />
      )}
      <ScrollTop threshold={200} />
    </>
  );
};

export default React.memo(FilterResults);
